import { ref, watch, onBeforeUnmount } from 'vue'
import {
  registerTutorialElement,
  unregisterTutorialElement
} from '@/feature/tutorialAgent/tutorialRegistry'

type TutorialRegisterOptions = {
  id: string
  label: string
  role?: string | null
  priority?: number | null
  state?: Record<string, string | number | boolean | null>
}

export const useTutorialRegister = (options: TutorialRegisterOptions) => {
  const targetRef = ref<HTMLElement | null>(null)
  let currentId: string | null = null

  watch(
    targetRef,
    (element, previous) => {
      if (previous && currentId) {
        unregisterTutorialElement(currentId)
      }
      if (element) {
        registerTutorialElement(element, {
          id: options.id,
          label: options.label,
          role: options.role ?? null,
          priority: options.priority ?? null,
          state: options.state
        })
        currentId = options.id
      }
    },
    { immediate: true }
  )

  onBeforeUnmount(() => {
    if (currentId) {
      unregisterTutorialElement(currentId)
    }
  })

  return {
    targetRef
  }
}
